import { useEffect, useState } from "react";
import "../ProductsInner.scss";
import "./strechYarn.scss";
import "../style.scss";

import {
  Leggings,
  Shirting,
  Sportswear,
  Suiting,
  Technicaltext4,
  Workwear,
  activewear,
  blueArrow,
  denims,
  dryCoolLogo,
  dryCoolPdf,
  dryCoolVideo,
  homeTextiles,
  knittedFabrics,
  strechYarn,
  strechYarnDigitalPdf,
  strechYarnPDP,
} from "../../../images";
import Dash from "../../../components/Dash/Dash";
import ProductsPopup from "../../../components/ProductsPopup/ProductsPopup";
import MetaDecorator from "../../../components/MetaDecorator/MetaDecorator";

const applicationData = [
  {
    id: 1,
    title: "Activewear",
    img: activewear,
  },
  {
    id: 2,
    title: "Sportswear",
    img: Sportswear,
  },
  {
    id: 3,
    title: "Legging's",
    img: Leggings,
  },
  {
    id: 4,
    title: "Workwear",
    img: Workwear,
  },
  {
    id: 5,
    title: "Home Textiles",
    img: homeTextiles,
  },
  {
    id: 6,
    title: "Suiting",
    img: Suiting,
  },
  {
    id: 7,
    title: "Shirting",
    img: Shirting,
  },
  {
    id: 8,
    title: "Denim & Cargo's",
    img: denims,
  },
];

const StrechYarn = () => {
  const [isModalOpen, setModalIsOpen] = useState(false);
  const currentURL = window.location.href;

  const toggleModal = () => {
    setModalIsOpen(!isModalOpen);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const applicationList = applicationData.map((item, i) => (
    <div className="col-lg-3 col-md-6 app_col" key={i}>
      <div className="app_box">
        <div className="img_wrapper px-0">
          <img src={item.img} alt={item.title} className="app_img" />
        </div>
        <p className="heading">{item.title}</p>
      </div>
    </div>
  ));
  return (
    <>
      <MetaDecorator
        canonicalLink={currentURL}
        metaTitle="Strech Yarn: High-Performance Polyester Yarn | Durable Elastic Fibre Yarn - Sanathan Textiles"
        metaDesc="Explore advanced stretch yarns engineered for elasticity, durability, and comfort. Ideal for activewear, denim, home textiles, and workwear. Discover polyester stretch yarn today from leading yarn manufacturers."
      />

      {isModalOpen && <ProductsPopup onRequestClose={toggleModal} />}
      <section className="products_inner">
        <div className="wrapper">
          <div className="breadcrumb_styles">Products {">"} Stretch Yarn</div>
          <div className="left_section">
            <p className="hollow_title">Products</p>
            <div className="dash_wrapper">
              <Dash />
            </div>
            <h1 className="yarns">Stretch Yarns</h1>
            <img className="drycool_img" src={strechYarn} alt="sanathan img" />
            {/* <h1 className="yarns">Dry Cool</h1> */}
            {/* <h4 className="capacity">6300 MTPA Manufacturing capacity</h4> */}
            <p>
              Stretch Yarns are innovative yarns designed to offer exceptional
              elasticity and comfort. By incorporating elastic fibers such as
              spandex, elastane, or Lycra, these yarns give excellent stretch
              and recovery to fabric. Thus, maintaining excellent garment
              stability. This property makes them ideal for activewear,
              swimwear, hosiery, and everyday apparel, providing superior
              comfort and flexibility. Allowing Freedom of Motion.
            </p>
            {/* <img src={coloredArrow} className="arrow" alt="sanathan img"/> */}
            <div className="bottom_arrow_container broch_link_wrap">
              <a
                href={strechYarnDigitalPdf}
                target="_blank"
                rel="noreferrer"
                className="broch_link"
              >
                Download Brochure
                <img
                  className="right_arrow"
                  src={blueArrow}
                  alt="sanathan img"
                />
              </a>
            </div>
          </div>
          <div className="right_section">
            <figure className="bg_img">
              <img src={strechYarnPDP} alt="sanathan img" />
            </figure>
          </div>
        </div>
      </section>

      <section className="products_inner_watch_now">
        <div className="wrapper">
          <div className="hollow_title">Watch Now</div>
          {/* <div className="video_section">
            <a>
              <img src={youtube_thumb} className="video_image" alt="sanathan img"/>
              <img
                src={playicon}
                className="playicon"alt="sanathan img"
                onClick={() =>
                  handleProjectVideoClick(
                    "https://www.youtube.com/embed/a6y1xzN1WD8"
                  )
                }
              />
            </a>
          </div> */}

          {/* <figure className="for_desk">
            <iframe
              width="100%"
              height="680"
              src="https://www.youtube.com/embed/YT4Dhl_uHd8"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </figure>
          <figure className="for_mob">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/YT4Dhl_uHd8"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </figure> */}

          {/* <div className="video_container"> */}
          {/* <video className="video_details" autoPlay muted loop playsInline>
              <source src={dryCoolVideo} type="video/mp4" />
              <source src={dryCoolVideo} type="video/ogg" />
            </video> */}
          {/* <iframe
              className="video_details"
              src="https://www.youtube.com/embed/nI_HIkMSqgk?autoplay=1&mute=1&loop=1&playlist=nI_HIkMSqgk&controls=0&modestbranding=1&rel=0&showinfo=0"
              title="Sanathan Stretch Yarns"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe> */}
          {/* </div> */}

          <figure className="for_desk">
            <iframe
              width="100%"
              height="680"
              src="https://www.youtube.com/embed/nI_HIkMSqgk?autoplay=1&mute=1&loop=1&playlist=nI_HIkMSqgk&controls=0&modestbranding=1&rel=0&showinfo=0"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </figure>
          <figure className="for_mob">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/nI_HIkMSqgk?autoplay=1&mute=1&loop=1&playlist=nI_HIkMSqgk&controls=0&modestbranding=1&rel=0&showinfo=0"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </figure>
        </div>
      </section>

      {/* <section className="products_inner_list">
        <div className="wrapper">
          <div className="products_inner_list_heading_wrapper">
            <div className="hollow_title">Manufacturing Unit</div> */}
      {/* <h3>
              Click on any product to view <br /> detailed information
            </h3> */}
      {/* </div>
          <div className="products_inner_listing">
            <div className="product_box">
              <figure>
                <img src={Technicaltext1} alt="sanathan img" />
              </figure> */}
      {/* <button className="tech_btn" onClick={toggleModal}>
                Partially Oriented Yarn
              </button> */}
      {/* </div>
            <div className="product_box">
              <figure>
                <img src={Technicaltext2} alt="sanathan img" />
              </figure> */}
      {/* <button className="tech_btn" onClick={toggleModal}>
                Fully Drawn Yarn
              </button> */}
      {/* </div>
            <div className="product_box">
              <figure>
                <img src={Technicaltext3} alt="sanathan img" />
              </figure> */}
      {/* <button className="tech_btn" onClick={toggleModal}>
                Draw Textured/Texturized Yarn
              </button> */}
      {/* </div>
          </div>
        </div>
      </section> */}

      <section className="technical_sec3">
        <div className="wrapper">
          <h3>Advantages:</h3>
          <div className="row">
            <div className="col-lg-4">
              <ul>
                <li>Enhanced Comfort</li>
                <li>Versatility</li>
              </ul>
            </div>
            <div className="col-lg-4">
              <ul>
                <li>Durability</li>
                <li>Improved Fit</li>
              </ul>
            </div>
            <div className="col-lg-4">
              <ul>
                <li>Shape Retention</li>
                {/* <li>Versatile</li> */}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="sflex_sec4">
        <div className="wrapper">
          <h3 className="title">Versatile Applications of Stretch Yarn</h3>
          <div className="row app_row">{applicationList}</div>
          {/* <div className="content_wrapper">
            <p className="app_desc">
              <span className="head">THE FUTURE OF STRETCH FABRICS</span>
              S-flex represents a paradigm shift in textile manufacturing. It
              combines the benefits of polyester with unprecedented stretch
              capabilities. This innovative value added yarn opens new
              possibilities for designers and manufacturers alike. By
              eliminating the need for spandex, S-flex simplifies production
              processes. It also enhances fabric performance and longevity. The
              result is a versatile, cost-effective solution for the modern
              textile industry.
            </p>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default StrechYarn;
